module.exports = __webpack_public_path__ + "img/whatsapp_ti.3060b625.png";